export default {
  // Validaciones de formulario de usuario
  user_name_error: 'You must enter at least one name',
  last_name_error: 'You must enter a surname or initial',
  email_error: 'You must enter a valid email',
  password_error: 'You must provide a password',
  password_format_error: 'The password must be at least 8 characters with numbers and letters',
  password_confirmation_error: 'Passwords must match',
  external_id_error: 'External ID must not exceed 100 characters',

  // Validaciones de selectores compartidos (roles, franquicias)
  role_error: 'Select a Role',
  roles_error: 'Select roles',
  select_franchise_error: 'You must select a franchise',

  // Otras validaciones
  logo_process_error: 'The logo image could not be processed',
  organization_save_error: 'The organization could not be saved',
  organization_delete_error: 'The organization could not be deleted',
  sort_type_error: 'The level sort type could not be updated',
  same_role: 'Roles cannot be the same',
  code_not_found: 'Code not found: {code}',
  scan_area: 'Place a barcode inside the scan area',
  scan_error: 'Error starting the scanner',
  scan_permission_denied: 'Camera permission is required to scan codes. Check the app permissions.',
  scan_module_installing: 'Preparing the scanner for the first time, try again in a few seconds.',

  // Formularios: campos obligatorios y validaciones de formularios/pruebas
  occurrence_open_forbidden: "You don't have this role assigned at this location.",
  occurrence_open_failed: 'The form could not be opened. Check your connection.',
  video_invalid: 'Unsupported video format.',
  photo_limit_reached: 'You already reached the limit of {limit} photos for this question.',
  photo_limit_truncated: 'Only {added} of {selected} selected photos were added (limit of {limit}).',
  addon_sync_failed: 'This question could not be synced with the server. Check your connection.',
  notify_comment_required: 'You must provide a comment',
  validation_name_required: 'You must enter a name',
  validation_role_required: 'You must choose a role',
  validation_audited_required: 'Select the auditee',
  validation_supervisor_required: 'Select the supervisor',
  validation_franchise_required: 'Select a business unit',
  signature_required_label: 'Main signature required',
  signature_secondary_required_label: 'Secondary signature required',
  signature_additional_required_label: 'Additional signatures required',
  validation_days_positive: 'Must be greater than 0',

  // Carga de imágenes y ubicaciones (encuestas, formularios asignados)
  image_upload_error: 'Error uploading the image',
  image_file_invalid: 'The file must be an image',
  locations_load_error: 'Could not load the locations. Check your connection.',

  // Licencias: razón de suspensión/reactivación
  reason_required: 'Pick a reason',
  reason_detail_required: 'Describe the reason',
  reason_detail_max: 'Maximum 2000 characters',

  // Occurrence: errors when finishing, syncing and authorizing
  occurrence_tasks_save_error: 'The tasks could not be saved',
  occurrence_deadline_expired: 'The time limit to send this form has expired',
  occurrence_not_saved: 'The information was not saved.',
  occurrence_sync_check_title: 'Validation error',
  occurrence_sync_check_error: 'An error occurred while checking the synchronization. Please try again.',
  occurrence_load_sync_error: 'The audit could not be loaded or synced',
  occurrence_authorize_error: 'The form could not be authorized',
  occurrence_signature_not_saved: 'The signature could not be saved. It will be sent again on the next save with a connection.',
  occurrence_signature_syncing: 'The signature is still syncing. Try deleting it in a few seconds.',
  occurrence_signature_delete_error: 'The signature could not be deleted. Please try again.',
  occurrence_document_not_saved: 'The document could not be saved. Please attach it again.',
  occurrence_comment_not_saved: 'The comment could not be saved. Please write it again.',
  occurrence_not_found_for_date: 'There is no form for the selected date',
  occurrence_answers_send_error: 'The answers could not be sent',
  occurrence_task_user_invalid: 'The assigned user could not be validated',
  occurrence_changes_save_error: 'The changes could not be saved',
  occurrence_task_duplicate: 'This task already exists in the audit',
  occurrence_only_documents_allowed: 'You can only upload documents',
  occurrence_document_show_error: 'The document could not be displayed, please try reloading the page.',
  occurrence_invalid_time: 'Invalid time',
  // Test form (FormTest*)
  form_test_add_comment_no_occurrence: 'Error: Cannot add a comment without a test occurrence',
  form_test_add_comment_error: 'Error adding test comment',
  form_test_add_picture_no_occurrence: 'Error: Cannot add an image without a test occurrence',
  form_test_add_picture_error: 'Error adding test image',
  form_test_save_comment_error: 'Error saving test comment',
  form_test_save_picture_error: 'Error saving test image'
}
